import { render, staticRenderFns } from "./NewAnnotationComponent.vue?vue&type=template&id=26b9c4ab&"
import script from "./NewAnnotationComponent.vue?vue&type=script&lang=js&"
export * from "./NewAnnotationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports